import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { default as mainTheme } from "Theme";
import styled from "styled-components";
import { Snackbar, useMediaQuery } from "@material-ui/core";
import { useStyles } from "Theme/styles";
import Alert from "@material-ui/lab/Alert";
import { PromptProps } from "react-router-dom";

const StepperIconsContainer = styled.div<{ highlighted: boolean }>`
  background-color: ${(props): string =>
    props.highlighted ? mainTheme.palette.secondary.light : "#FFFFFF"};
  width: 100%;
  padding: 16px;
  border: 1px solid #dee5ef;
  border-radius: 5px;
`;

export interface InvalidationCheck {
  invalid: boolean;
  message?: string;
}
export interface StepFrame {
  label: string;
  children: any;
  stepIndex?: number;
  inValid?: InvalidationCheck;
}
export interface StepperFrameProps {
  stepFrames: StepFrame[];
  secondary?: boolean;
  cancellable?: boolean;
  handleCancel?: () => void;
  handleSubmit: () => void;
  highlighted?: boolean;
  handleNext?: (step: number) => void;
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     step: {
//       "& $completed": {
//         color: mainTheme.palette.secondary.light,
//       },
//       "& $active": {
//         color: mainTheme.palette.secondary.dark,
//       },
//       "& $disabled": {
//         color: mainTheme.palette.primary.light,
//       },
//     },
//   },
//   button: {
//     marginRight: theme.spacing(1),
//   },
//   instructions: {
//     marginTop: theme.spacing(1),
//     marginBottom: theme.spacing(1),
//   },
//   primary: {},
//   step: {
//     "& $completed": {
//       color: mainTheme.palette.secondary.light,
//     },
//     "& $active": {
//       color: mainTheme.palette.secondary.dark,
//     },
//     "& $disabled": {
//       color: mainTheme.palette.primary.light,
//     },
//   },
// }));

export default function StepperFrame({
  stepFrames,
  secondary = false,
  cancellable = false,
  highlighted = false,
  handleCancel,
  handleSubmit,
  handleNext,
}: StepperFrameProps) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [open, setOpen] = React.useState(false);
  //   const isStepOptional = (step) => {
  //     return step === 1;
  //   };

  //   const isStepSkipped = (step) => {
  //     return skipped.has(step);
  //   };

  const _handleNext = () => {
    let newSkipped = skipped;
    const currentStep = stepFrames[activeStep];
    if (currentStep.inValid?.invalid) {
      //make toast
      setOpen(true);
      return;
    }
    // if (isStepSkipped(activeStep)) {
    //   newSkipped = new Set(newSkipped.values());
    //   newSkipped.delete(activeStep);
    // }
    if (handleNext) {
      handleNext(activeStep);
    }
    if (activeStep === stepFrames.length - 1) {
      handleSubmit();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  //   const handleSkip = () => {
  //     if (!isStepOptional(activeStep)) {
  //       throw new Error("You can't skip a step that isn't optional.");
  //     }

  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //     setSkipped((prevSkipped) => {
  //       const newSkipped = new Set(prevSkipped.values());
  //       newSkipped.add(activeStep);
  //       return newSkipped;
  //     });
  //   };

  const handleReset = () => {
    setActiveStep(0);
  };

  const cancel = cancellable ? (
    <Button onClick={handleCancel} className={classes.button}>
      Cancel
    </Button>
  ) : null;

  const handleClose = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const isDesktop = useMediaQuery("(min-width:600px)");

  return (
    <div className={classes.stepFrames}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={stepFrames[activeStep]?.inValid?.message}
      >
        {/*// @ts-ignore */}
        <Alert variant="outlined" severity="error">
          {stepFrames[activeStep]?.inValid?.message}
        </Alert>
      </Snackbar>

      <StepperIconsContainer highlighted={highlighted}>
        <Stepper
          activeStep={activeStep}
          orientation={isDesktop ? "horizontal" : "vertical"}
        >
          {stepFrames.map((stepFrame, index) => {
            const stepProps = {};
            const labelProps = {};

            //   if (isStepOptional(index)) {
            //     labelProps.optional = (
            //       <Typography variant="caption">Optional</Typography>
            //     );
            //   }
            //   if (isStepSkipped(index)) {
            //     stepProps.completed = false;
            //   }

            return (
              <Step
                key={index}
                {...stepProps}
                className={secondary ? classes.step : classes.primary}
              >
                <StepLabel {...labelProps}>{stepFrame.label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {
            <div>
              {stepFrames[activeStep]?.children}
              <div>
                {cancel}
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                >
                  Back
                </Button>
                {/* {isStepOptional(activeStep) && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSkip}
                  className={classes.button}
                >
                  Skip
                </Button>
              )} */}

                <Button
                  variant="contained"
                  color="primary"
                  onClick={_handleNext}
                  className={classes.button}
                >
                  {activeStep === stepFrames.length - 1 ? "Finish" : "Next"}
                </Button>
              </div>
            </div>
          }
        </div>
      </StepperIconsContainer>
    </div>
  );
}
